<!--
 * @Author: Ximen
 * @Date: 2021-03-17 14:12:51
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-21 11:04:29
-->
<template>
  <div class="bg">
    <div style="height:100%">
      <SupplementaryInformation class="mt" style="margin-top:247px;" v-if="step===1"/>
      <CreateShop class="mt" style="margin-top:165px" v-if="step===2"/>
      <CreateSuccess class="mt" style="margin-top:258px" v-if="step===3"/>
      <CertifiedShop class="mt" style="margin-top:128px" v-if="step===4&&AuthenticationStatus===0"/>
      <SubmitSuccess class="mt" style="margin-top:196px" v-if="step===4&&AuthenticationStatus===1"/>
    </div>
  </div>
</template>

<script lang='ts'>
import commonApi from '@/api/common';
import { defineComponent } from 'vue';
import { message as $message } from 'ant-design-vue';
import SupplementaryInformation from './components/supplementaryInformation.vue';
import CreateShop from './components/createShop.vue';
import CreateSuccess from './components/createSuccess.vue';
import CertifiedShop from './components/certifiedShop.vue';
import SubmitSuccess from './components/submitSuccess.vue';

export default defineComponent({
  name: 'Home',
  components: {
    SupplementaryInformation,
    CreateShop,
    CreateSuccess,
    CertifiedShop,
    SubmitSuccess,
  },
  data() {
    return {
      shopInfo: {
        shopName: '',
        shopVerifySubmitStatus: 0,
      },
      step: 2,
      AuthenticationStatus: 0,
    };
  },
  setup() {
    const error = (str: string) => {
      $message.error(str);
    };
    const success = (str: string) => {
      $message.success(str);
    };
    return {
      error,
      success,
    };
  },
  mounted() {
    this.getShopInfo();
  },
  methods: {
    goToAuthorize() {
      this.$router.push('/authorize');
    },
    // 进入创建店铺
    nextStep(num: number) {
      this.step = num;
    },
    nextAuthenticationStatus(num: number) {
      this.AuthenticationStatus = num;
    },
    getShopInfo() {
      interface Data{
        data: Shopinfo;
        success: boolean;
        message: string;
      }
      interface Shopinfo{
        shopName: string;
        shopVerifySubmitStatus: number;
      }
      const param = {
        memberId: localStorage.getItem('memberId'),
      };
      commonApi.getShopInfo(param).then(async ({ data, success, message }: Data) => {
        if (success) {
          this.shopInfo = data;
          if (!data.shopName) {
            const store = (this as any).$store;
            store.state.isShowGoBack = false;
          }
          if (!this.shopInfo.shopName) {
            this.step = 2;
            return;
          }
          this.$router.push('/logIn');

          // if (this.shopInfo.shopVerifySubmitStatus === 0) {
          //   this.step = 4;
          //   this.AuthenticationStatus = 0;
          //   return;
          // }
          // if (this.shopInfo.shopVerifySubmitStatus === 1) {
          //   this.step = 4;
          //   this.AuthenticationStatus = 1;
          //   return;
          // }
          console.log(data);
        } else {
          console.log(message);
          this.error(message);
        }
      });
    },
  },
});
</script>
<style lang="stylus" scoped>
  .bg
    background url('../../assets/background.jpg') no-repeat;
    background-size 100% 100%
    width 100%
    min-height 100vh
    overflow: hidden;
    .mt
      margin-bottom 200px
      .title
        font-size 24px
        color #073D7D
        margin-bottom 40px
      .blank
        width 220px
        height auto
        margin-bottom 40px
      .accept-btn
        width 100%
        height 50px
        margin-top 10px
        border-radius 5px
        background #3281DD
        margin-bottom 30px
      .consulting
        font-size 14px
        color #000
</style>
